const user_identity_details = {
    social_identity_page_title: 'Сведения о социальной идентичности',
    back_to_user_details: 'Вернуться к сведениям о пользователе',
    delete_identity: `Удалить связь с идентичностью`,
    social_account: {
        title: 'Социальный аккаунт',
        description: 'Просмотр данных пользователя и информации профиля, синхронизированных с подключённого аккаунта {{connectorName}}.',
        provider_name: 'Название провайдера социальной идентичности',
        identity_id: 'ID социальной идентичности',
        user_profile: 'Профиль пользователя, синхронизированный с провайдером социальной идентичности',
    },
    sso_account: {
        title: 'Учетная запись корпоративного SSO',
        description: 'Просмотр данных пользователя и информации профиля, синхронизированных с подключённого аккаунта {{connectorName}}.',
        provider_name: 'Название провайдера корпоративной SSO идентичности',
        identity_id: 'ID корпоративной SSO идентичности',
        user_profile: 'Профиль пользователя, синхронизированный с провайдером корпоративной SSO идентичности',
    },
    token_storage: {
        title: 'Токен доступа',
        description: 'Храните токены доступа и обновления из {{connectorName}} в Secret Vault. Это позволяет выполнять автоматизированные вызовы API без повторного согласия пользователя.',
    },
    access_token: {
        title: 'Токен доступа',
        description_active: 'Токен доступа активен и надёжно хранится в Secret Vault. Ваш продукт может использовать его для обращения к API {{connectorName}}.',
        description_inactive: 'Этот токен доступа неактивен (например, отозван). Пользователи должны повторно авторизоваться для восстановления функциональности.',
        description_expired: 'Этот токен доступа истёк. Обновление происходит автоматически при следующем запросе к API с использованием токена обновления. Если токен обновления недоступен, требуется повторная аутентификация пользователя.',
    },
    refresh_token: {
        available: 'Токен обновления доступен. Если токен доступа истекает, он будет автоматически обновлён с использованием токена обновления.',
        not_available: 'Токен обновления недоступен. После истечения срока действия токена доступа пользователи должны повторно пройти аутентификацию, чтобы получить новые токены.',
    },
    token_status: 'Статус токена',
    created_at: 'Создан',
    updated_at: 'Обновлён',
    expires_at: 'Истекает',
    scopes: 'Области',
    delete_tokens: {
        title: 'Удаление токенов',
        description: 'Удалите сохранённые токены. Пользователи должны повторно авторизоваться, чтобы восстановить функциональность.',
        confirmation_message: 'Вы уверены, что хотите удалить токены? Logto Secret Vault удалит сохранённые токены доступа и обновления {{connectorName}}. Этот пользователь должен повторно авторизоваться, чтобы восстановить доступ к API {{connectorName}}.',
    },
    token_storage_disabled: {
        title: 'Хранение токенов отключено для этого соединителя',
        description: 'Пользователи могут в настоящее время использовать {{connectorName}} только для входа в систему, связывания учетных записей или синхронизации профилей во время каждого потока согласия. Чтобы получить доступ к API {{connectorName}} и выполнять действия от имени пользователей, пожалуйста, включите хранение токенов в',
    },
};
export default Object.freeze(user_identity_details);
